export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnXUserGroupAdded':
      return onXUserGroupAdded(state, action);
    case 'OnXUserGroupDeleted':
      return onXUserGroupDeleted(state, action);
    case 'OnXUserGroupsSave':
      return onXUserGroupsSave(state, action);
    case 'OnSetAllBegin':
      return onSetAllBegin(state, action);
    case 'OnSetAll':
      return onSetAll(state, action);
    default:
      return state;
  }
}
export const initialState = {
  selectedUserGroups: [],
  selectedUserGroupsChanged: false,
  setAllCheckbox: false,
  setAllChanged: false
};

function onInitState(state, action) {
  return {
    ...state,
    selectedUserGroups: action.xUserGroups.map(item => {
      return { userGroupId: item.userGroupId };
    }),
    selectedUserGroupsChanged: false
  };
}

function onXUserGroupsSave(state, _action) {
  return {
    ...state,
    selectedUserGroupsChanged: false
  };
}

function onXUserGroupAdded(state, action) {
  return {
    ...state,
    selectedUserGroupsChanged: true,
    selectedUserGroups: [...state.selectedUserGroups, { userGroupId: action.userGroupId }]
  };
}

function onXUserGroupDeleted(state, action) {
  return {
    ...state,
    selectedUserGroupsChanged: true,
    selectedUserGroups: [...state.selectedUserGroups].filter(x => x.userGroupId !== action.userGroupId)
  };
}

function onSetAllBegin(state, action) {
  return {
    ...state,
    setAllCheckbox: action.checkedValue,
    setAllChanged: true
  };
}

function onSetAll(state, action) {
  const { checkedValue, userGroups } = action;
  if (checkedValue)
    return {
      ...state,
      selectedUserGroupsChanged: true,
      setAllChanged: false,
      selectedUserGroups: userGroups.map(item => {
        return {
          userGroupId: item.id
        };
      })
    };
  else
    return {
      ...state,
      selectedUserGroupsChanged: true,
      setAllChanged: false,
      selectedUserGroups: []
    };
}
